import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { getUser } from 'src/user';
import { getToken } from 'src/auth';
;
import { Button, Columns, Column, MuiTitle } from 'src/ui/mui-ui-kit';;;
import { setBreadcrumbs, InnerLoader, UiToastAdapter } from 'src/ui';
import { toast } from 'react-toastify';
import propTypes from 'prop-types';
import { LicenseTable, LicenseEditModal } from '../components';
import {
  getLicenses,
  fetchLicenses,
  submitLicenses,
  updateLicense,
} from '../redux';

/* eslint-disable no-param-reassign */
const LicenseAdminListPage = ({
  licenses,
  fetchLicenses,
  token,
  submitLicenses,
  updateLicense,
}) => {
  const [loading, setLoading] = useState(true);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState({
    visible: false,
    data: {},
  });

  const showModal = React.useCallback(
    lic => {
      setIsModalVisible({ visible: true, data: lic });
    },
    [isModalVisible]
  );

  const handleSelectAll = () => {
    setSelectAll(prevSelectAll => !prevSelectAll);
    if (selectAll) {
      setSelectedRows([]);
    } else {
      setSelectedRows([]);
      const allRowIds = licenses.licenses.map(row => row.id);
      setSelectedRows(allRowIds);
    }
  };

  const onSubmit = async () => {
    try {
      setLoading(true);
      const result = await submitLicenses({
        licenseIds: selectedRows,
      });
      if (result.error) {
        const errorMessage = result.payload.response.detail;
        toast(UiToastAdapter(errorMessage, 'danger'));
        setLoading(false);
        setSelectedRows([]);
      } else {
        setLoading(false);
        toast(
          UiToastAdapter(
            `${selectedRows.length} licenses successfully submitted!`,
            'success'
          )
        );
        setSelectedRows([]);
      }
    } catch (e) {
      toast(UiToastAdapter('An unexpected error occurred.', 'danger'));
      setLoading(false);
      setSelectedRows([]);
    }
  };

  const onModalSubmit = async val => {
    try {
      setLoading(true);
      setIsModalVisible({ visible: false, data: {} });
      const result = await updateLicense({
        id: val.id,
        licenseLink: val.licenseLink || null,
        consentLink: val.consentLink || null,
      });
      if (result.error) {
        const errorMessage = result.payload.response.detail;
        toast(UiToastAdapter(errorMessage, 'danger'));
        setLoading(false);
      } else {
        setLoading(false);
        toast(
          UiToastAdapter(
            `${val.licenseNumber}  successfully updated!`,
            'success'
          )
        );
      }
    } catch (e) {
      toast(UiToastAdapter('An unexpected error occurred.', 'danger'));
      setLoading(false);
    }
  };

  const toggleRowSelection = row => {
    row.isChecked = !row.isChecked;
    row = row._original;
    setSelectedRows(prevSelectedRows => {
      // Create a new array with the updated selection
      if (prevSelectedRows.includes(row.id)) {
        return prevSelectedRows.filter(dataRowId => dataRowId !== row.id);
      }
      return [...prevSelectedRows, row.id];
    });
  };

  useEffect(() => {
    (async () => {
      setBreadcrumbs([{ label: 'Licenses', href: '/licenses' }]);
      if (token.isValid()) {
        await fetchLicenses();
        setLoading(false);
      }
    })();
  }, []);
  return (
    <>
      <Columns isMultiline>
        <LicenseEditModal
          isActive={isModalVisible.visible}
          data={isModalVisible.data}
          onClickClose={() => setIsModalVisible({ visible: false, data: {} })}
          onSubmit={onModalSubmit}
        />
        <Column isSize="1/2">
          <MuiTitle isSize="4" hasTextColor="info" tag="h2">
            Licenses
          </MuiTitle>
        </Column>
        <Column isSize="1/2">
          <Button
            className="is-long is-pulled-right"
            disabled={!selectedRows.length}
            isColor="gradient-bright"
            onClick={() => onSubmit()}
          >
            Submit
          </Button>
        </Column>

        <Column>
          {!loading && !licenses.isLoading() ? (
            <LicenseTable
              data={licenses.licenses}
              loading={loading}
              toggleRowSelection={toggleRowSelection}
              selectedRows={selectedRows}
              handleSelectAll={handleSelectAll}
              showModal={showModal}
            />
          ) : (
            <InnerLoader visible />
          )}
        </Column>
      </Columns>
    </>
  );
};

function mapStateToProps(state) {
  return {
    user: getUser(state),
    licenses: getLicenses(state),
    token: getToken(state),
    //   account: getAccount(state),
    //   people: getInsurancePeople(state),
  };
}
LicenseAdminListPage.propTypes = {
  token: propTypes.object.isRequired,
  updateLicense: propTypes.func.isRequired,
  fetchLicenses: propTypes.func.isRequired,
  submitLicenses: propTypes.func.isRequired,
  licenses: propTypes.object.isRequired,
};
const connectedLicenseAdminListPage = connect(mapStateToProps, {
  setBreadcrumbs,
  fetchLicenses,
  submitLicenses,
  updateLicense,
})(LicenseAdminListPage);

export { connectedLicenseAdminListPage as LicenseAdminListPage };
